import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}><g fill="#e44444" fillRule="evenodd"><path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2" /><path fill="#FFF" d="M16 8.732l-.709-.713-3.289 3.27L8.732 8l-.713.709 3.27 3.289L8 15.268l.709.713 3.289-3.27L15.268 16l.713-.709-3.27-3.289z" /></g></svg>);